import { DocumentGroup } from './DocumentGroup';

export interface RequiredLink {
  label: {
    en: string;
    hi: string;
  };
  url: string;
}

export interface FormItem {
  id: string;
  categoryId: string;
  name: string;
  shortDescription: string;
  whoCanApply: string;
  applicableStates: string[];
  portalLink: string;
  formPdfPath?: string;
  requiredDocuments: string[];
  steps: string[];
  commonMistakes: string[];
  requiredLinks?: RequiredLink[];
  isActive: boolean;
  popularity: number;
  priority: number;
  adsAllowed: boolean;
  isSensitive: boolean;
  _rawNameMap?: Record<string, any>;
  _rawShortDescMap?: Record<string, any>;
  _rawWhoCanApplyMap?: Record<string, any>;
  _rawRequiredDocuments?: any;
  _rawSteps?: any;
  _rawCommonMistakes?: any;
}

export const hasGroupedDocuments = (
  form: FormItem,
  lang: string
): boolean => {
  const raw = form._rawRequiredDocuments;
  if (!raw) return false;
  
  const langData = raw[lang] || raw;
  return Array.isArray(langData) && 
         langData.length > 0 && 
         typeof langData[0] === 'object' && 
         'type' in langData[0];
};

export const getGroupedDocuments = (
  form: FormItem,
  lang: string
): DocumentGroup[] => {
  const raw = form._rawRequiredDocuments;
  if (!raw) return [];
  
  const langData = raw[lang] || raw;
  if (Array.isArray(langData) && typeof langData[0] === 'object') {
    return langData as DocumentGroup[];
  }
  return [];
};

export const getLocalizedName = (form: FormItem, lang: string): string => {
  return form._rawNameMap?.[lang] || form.name;
};

export const getLocalizedShortDescription = (form: FormItem, lang: string): string => {
  return form._rawShortDescMap?.[lang] || form.shortDescription;
};

export const getLocalizedWhoCanApply = (form: FormItem, lang: string): string => {
  return form._rawWhoCanApplyMap?.[lang] || form.whoCanApply;
};

export const getLocalizedRequiredLinks = (
  form: FormItem,
  lang: string
): Array<{ label: string; url: string }> => {
  if (!form.requiredLinks || !Array.isArray(form.requiredLinks)) {
    return [];
  }
  
  return form.requiredLinks.map(link => ({
    label: link.label?.[lang as 'en' | 'hi'] || link.label?.en || '',
    url: link.url || ''
  })).filter(link => link.label && link.url);
};
